goog.provide("shadow.js.shim.module$ol$geom$Point");
goog.provide("module$shadow_js_shim_module$ol$geom$Point");
shadow.js.shim.module$ol$geom$Point = shadow.js.nativeProvides["ol/geom/Point"] = shadow$bridge("ol/geom/Point");
module$shadow_js_shim_module$ol$geom$Point.default = shadow.js.shim.module$ol$geom$Point;
